import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ComentarioCasoModel,
  ComentarioCasoService,
} from 'src/app/services/comentariosCasos.service';
import {
  CommentCase,
  CommentCaseCreate,
} from '../../../interface/comment.interface';
import { CaseCommentService } from '../../../services/case-comment.service';

@Component({
  selector: 'case-comment',
  templateUrl: './case-comment.component.html',
  styleUrls: ['./case-comment.component.scss'],
})
export class CaseCommentComponent implements OnInit {
  comments = [];

  idCaso;
  constructor(
    private readonly caseCommentService: CaseCommentService,
    private readonly route: ActivatedRoute
  ) {
    this.idCaso = this.route.snapshot.paramMap.get('id');
    console.log(this.idCaso)
    this.caseCommentService.getCommentsByCase(this.idCaso).subscribe({
      next: (comments) => {
        this.comments = comments;
      },
    });
  }

  ngOnInit() {}

  comment: string;

  createComment() {
    if (!this.comment) return;
    const comment: CommentCaseCreate = {
      case: this.idCaso,
      comment: this.comment,
      deleted: false,
    };
    this.caseCommentService.createComment(comment).subscribe((resp: any) => {
      this.comments.push(resp);
    });
    this.comment = '';
  }
}
